/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Time_Management14Inputs */

const en_job_form_enum_time_management14 = /** @type {(inputs: Job_Form_Enum_Time_Management14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Management`)
};

const de_job_form_enum_time_management14 = /** @type {(inputs: Job_Form_Enum_Time_Management14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitmanagement`)
};

/**
* | output |
* | --- |
* | "Time Management" |
*
* @param {Job_Form_Enum_Time_Management14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_time_management14 = /** @type {((inputs?: Job_Form_Enum_Time_Management14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Time_Management14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_time_management14(inputs)
	return en_job_form_enum_time_management14(inputs)
});
export { job_form_enum_time_management14 as "job_form_enum_TIME_MANAGEMENT" }